export default __webpack_public_path__ + "static/media/six_protocol.a12785fe.png";